'use client';

import React from 'react';

export function BestRibbonV2() {
  const id = React.useId().replace(/:/g, '-');
  const clipId = `clip0-best-${id}`;
  const filterId = `filter0_d-best-${id}`;
  const paint0 = `paint0_linear-best-${id}`;
  const paint1 = `paint1_radial-best-${id}`;
  const paint2 = `paint2_linear-best-${id}`;

  return (
    <div className="absolute top-[-5px] left-[-5px] z-10 overflow-clip">
      <svg
        width="46"
        height="34"
        viewBox="0 0 46 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath={`url(#${clipId})`}>
          <path
            d="M0 26C0 27.8286 2.24286 29.3071 5 29.3071V10.9643L0 12.3429V26Z"
            fill={`url(#${paint0})`}
          />
          <path
            style={{ mixBlendMode: 'multiply' }}
            d="M4.9851 8C2.24224 8 0.0136719 13.8 0.0136719 20.9643C0.0136719 28.1286 2.24224 33.9286 4.9851 33.9286V8Z"
            fill={`url(#${paint1})`}
          />
          <path
            d="M39.5503 0H5.04446C2.2628 0 0 2.68752 0 4.9507V26C0 23.7368 2.2628 21.9068 5.04446 21.9068H39.5503L46 10.9534L39.5503 0Z"
            fill={`url(#${paint2})`}
          />
          <g filter={`url(#${filterId})`}>
            <path
              d="M6.41602 16V6.10156H10.2031C12.3496 6.10156 13.416 7.19531 13.416 8.67188C13.416 9.875 12.6504 10.5449 11.6797 10.7773V10.873C12.7324 10.9277 13.7988 11.8027 13.7988 13.3066C13.7988 14.8516 12.6914 16 10.4219 16H6.41602ZM10.1484 14.5098C11.4473 14.5098 11.9941 13.9492 11.9941 13.1699C11.9941 12.2812 11.2969 11.5977 10.1895 11.5977H8.19336V14.5098H10.1484ZM9.98438 10.3125C10.9277 10.3125 11.6387 9.76562 11.6387 8.89062C11.6387 8.125 11.0918 7.57812 10.0254 7.57812H8.19336V10.3125H9.98438ZM14.828 16V6.10156H21.2675V7.5918H16.6054V10.2988H20.9257V11.7891H16.6054V14.4961H21.2948V16H14.828ZM27.9432 8.82227C27.8612 7.97461 27.1366 7.48242 26.0702 7.48242C24.9491 7.48242 24.2655 8.0293 24.2655 8.76758C24.2655 9.60156 25.1405 9.94336 25.9608 10.1348L26.8905 10.3809C28.367 10.7227 29.7889 11.502 29.7889 13.2246C29.7889 14.9609 28.4217 16.1504 26.0428 16.1504C23.7323 16.1504 22.283 15.043 22.201 13.0879H23.951C24.033 14.127 24.908 14.6328 26.0291 14.6328C27.2049 14.6328 28.0116 14.0586 28.0116 13.2109C28.0116 12.4316 27.287 12.1035 26.2205 11.8301L25.0995 11.543C23.4725 11.1191 22.4608 10.2988 22.4608 8.87695C22.4608 7.12695 24.0194 5.96484 26.0975 5.96484C28.203 5.96484 29.6248 7.1543 29.6522 8.82227H27.9432ZM30.408 7.5918V6.10156H38.2966V7.5918H35.2478V16H33.4705V7.5918H30.408Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <filter
            id={filterId}
            x="3.41602"
            y="2.96484"
            width="37.8809"
            height="16.1855"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.279729 0 0 0 0 0.0750227 0 0 0 0 0.0796751 0 0 0 0.8 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <linearGradient
            id={paint0}
            x1="0"
            y1="20.1326"
            x2="5"
            y2="20.1326"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.245192" stopColor="#09807E" />
            <stop offset="1" stopColor="#35FFFC" />
          </linearGradient>
          <radialGradient
            id={paint1}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(4.42596 20.2286) scale(4.55314 12.6137)"
          >
            <stop stopColor="#131313" />
            <stop offset="0.15" stopColor="#505050" />
            <stop offset="0.3" stopColor="#858585" />
            <stop offset="0.45" stopColor="#B1B1B1" />
            <stop offset="0.58" stopColor="#D3D3D3" />
            <stop offset="0.71" stopColor="#EBEBEB" />
            <stop offset="0.83" stopColor="#F9F9F9" />
            <stop offset="0.94" stopColor="white" />
          </radialGradient>
          <linearGradient
            id={paint2}
            x1="0"
            y1="12.9956"
            x2="47"
            y2="12.9956"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#10C2C0" />
            <stop offset="0.245433" stopColor="#0FE5E1" />
            <stop offset="1" stopColor="#0FE5E1" />
          </linearGradient>
          <clipPath id={clipId}>
            <rect width="46" height="34" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
